/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderLineOptionDto
 */
export interface OrderLineOptionDto {
    /**
     * 
     * @type {string}
     * @memberof OrderLineOptionDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderLineOptionDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof OrderLineOptionDto
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof OrderLineOptionDto
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof OrderLineOptionDto
     */
    takeawayPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderLineOptionDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof OrderLineOptionDto
     */
    itemVariantId: string;
}

/**
 * Check if a given object implements the OrderLineOptionDto interface.
 */
export function instanceOfOrderLineOptionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "quantity" in value;
    isInstance = isInstance && "price" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "itemVariantId" in value;

    return isInstance;
}

export function OrderLineOptionDtoFromJSON(json: any): OrderLineOptionDto {
    return OrderLineOptionDtoFromJSONTyped(json, false);
}

export function OrderLineOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderLineOptionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'quantity': json['quantity'],
        'price': json['price'],
        'takeawayPrice': !exists(json, 'takeawayPrice') ? undefined : json['takeawayPrice'],
        'type': json['type'],
        'itemVariantId': json['itemVariantId'],
    };
}

export function OrderLineOptionDtoToJSON(value?: OrderLineOptionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'quantity': value.quantity,
        'price': value.price,
        'takeawayPrice': value.takeawayPrice,
        'type': value.type,
        'itemVariantId': value.itemVariantId,
    };
}

